import { z } from 'zod';
export class FillJustification {
    constructor(id, attendeeId, status, statusUpdatedAt, formKey) {
        this.id = id;
        this.attendeeId = attendeeId;
        this.status = status;
        this.statusUpdatedAt = statusUpdatedAt;
        this.formKey = formKey;
    }
}
export const isMainFillJustification = (fillJustification) => {
    return fillJustification.formKey === null;
};
export const isAdditionalFillJustification = (fillJustification) => {
    return fillJustification.formKey !== null;
};
export const getMainFillJustification = (fillJustifications) => {
    return fillJustifications.find(isMainFillJustification);
};
export const getAdditionalFillJustifications = (fillJustifications) => {
    return fillJustifications.filter(isAdditionalFillJustification);
};
export const AdditionalDocumentFormResponseSchema = z.object({
    additionalDocumentId: z.string().optional()
});
